import { Controller } from '@hotwired/stimulus';
import Chart from 'chart.js/auto';

export default class extends Controller {
  static values = {
    actualData: Array,
    target: Number,
    labels: Array,
    weekBands: Array,
    weekStarts: Array,
    tooltipTitles: Array,
  };

  connect() {
    const {
      actualDataValue: actual,
      targetValue: target,
      labelsValue: labels,
      weekBandsValue: bands,
      weekStartsValue: weekStarts,
      tooltipTitlesValue: tooltipTitles,
    } = this;
    const pace = labels.map((_, i) => Math.round(((i + 1) * target) / labels.length));
    const barColors = bands.map((w) => (w === 0 ? 'rgba(29,93,234,0.70)' : 'rgba(29,93,234,0.28)'));
    const barHoverColors = bands.map((w) =>
      w === 0 ? 'rgba(29,93,234,0.90)' : 'rgba(29,93,234,0.55)',
    );

    this.chart = new Chart(this.element, {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            type: 'bar',
            data: actual,
            backgroundColor: barColors,
            hoverBackgroundColor: barHoverColors,
            borderRadius: 3,
            borderSkipped: false,
            barPercentage: 0.75,
          },
          {
            type: 'line',
            data: pace,
            borderColor: 'rgba(184,27,88,0.45)',
            borderDash: [5, 3],
            borderWidth: 1.5,
            pointRadius: 0,
            fill: false,
            tension: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 600, easing: 'easeOutQuart' },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: (items) => tooltipTitles[items[0]?.dataIndex] || '',
              label: (ctx) => {
                if (ctx.datasetIndex === 1) return ` Target £${(ctx.raw / 1000).toFixed(0)}k`;
                const cum = ctx.raw;
                if (cum == null) return '';
                const p = Math.round(((ctx.dataIndex + 1) * target) / labels.length);
                const diff = cum - p;
                const diffFmt = '£' + Math.abs(diff).toLocaleString('en-GB');
                const paceLabel =
                  diff >= 0 ? `${diffFmt} ahead of target` : `${diffFmt} behind target`;
                return [` Cumulative £${cum.toLocaleString('en-GB')}`, ` ${paceLabel}`];
              },
            },
          },
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              maxRotation: 0,
              autoSkip: false,
              callback: (_val, index) => (weekStarts[index] ? labels[index] : null),
              font: {
                size: 12,
                family: 'Inter, ui-sans-serif, system-ui, sans-serif',
                weight: '700',
              },
              color: 'rgba(31,4,15,0.7)',
            },
            border: { display: false },
          },
          y: {
          display: false,
          beginAtZero: true,
          max: target > 0 ? Math.round(target * 1.05) : undefined,
        },
        },
      },
    });
  }

  disconnect() {
    this.chart?.destroy();
  }
}
